module.exports = __webpack_public_path__ + "img/yancao_shifang2_suoluetu.8de6f7e9.png";